import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import { useGetPlaylistById } from 'api/video-repository/useAPIPlaylists'
import {
  VideoDescriptionShimmer,
  VideoCardShimmer,
  VideoCountShimmer,
} from 'app/VideoRepository/components/Preloader'
import Playlist from 'app/VideoRepository/Playlist'
import { EmptyState, EmptyStateAction } from 'components/EmptyState'
import AndroidHandler from 'utils/androidHandler'

const VideoRepositoryById = () => {
  const { query } = useRouter()
  const { data, isSuccess, isError, isLoading } = useGetPlaylistById(
    query.id as string
  )
  const containerRef = React.useRef<HTMLDivElement>(null)
  const router = useRouter()
  const androidHandler = AndroidHandler()

  return (
    <>
      <Head>
        <title>Video Inspirasi | {data?.data?.name ?? 'Playlists'} </title>
      </Head>
      <HeaderBar fixed borderless variant="large">
        <HeaderBarLeftAction
          icon={<Icon as="i">arrow_back</Icon>}
          onClick={() => {
            if (window.history.length <= 2) {
              if (androidHandler.enabled) {
                androidHandler.backToApp()
              } else {
                router.replace('/')
              }
            } else {
              router.back()
            }
          }}
        />
        <HeaderBarTitle>{data?.data?.name}</HeaderBarTitle>
      </HeaderBar>
      <div
        ref={containerRef}
        className="bg-default"
        style={{
          minHeight: 'calc(100vh - 3.5rem)',
        }}
      >
        {isLoading && (
          <>
            <div
              className="p-4 bg-white"
              style={{
                boxShadow:
                  '0 2px 1px rgba(0, 0, 0, .05), 0 0 1px rgba(0, 0, 0, .25)',
              }}
            >
              <VideoDescriptionShimmer />
            </div>
            <div className="p-4">
              <VideoCountShimmer />
              {[...Array(4)].map((_, index) => (
                <VideoCardShimmer key={index} />
              ))}
            </div>
          </>
        )}
        {isSuccess && (
          <Playlist
            containerRef={containerRef}
            name={data?.data?.name}
            playlistId={data?.data?.id}
            shortDescription={data?.data?.shortDescription}
            videos={data?.data?.videos}
            videoCount={data?.data?.videos?.length ?? ''}
            longDescription={data?.data?.longDescription}
            reviewer={data?.data?.reviewer}
          />
        )}
        {isError && (
          <EmptyState
            title={'Gagal mengambil data'}
            description={'Data Repository tidak dapat diakses'}
          >
            <EmptyStateAction onClick={() => window.location.reload()}>
              Muat Ulang
            </EmptyStateAction>
          </EmptyState>
        )}
      </div>
    </>
  )
}

VideoRepositoryById.layoutOpts = {
  className: 'pt-[94px]',
}

export default VideoRepositoryById
